var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightTurn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 12,
    width: 16.9706,
    height: 16.9706,
    rx: 0.754259,
    transform: "rotate(-45 0 12)",
    fill: "#FEDF12"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.262649,
    y: 12,
    width: 16.5934,
    height: 16.5934,
    rx: 0.628549,
    transform: "rotate(-45 0.262649 12)",
    fill: "#FEDF12",
    stroke: "black",
    strokeWidth: 0.25142
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.16579 17.6682H9.67995V10.9742H13.7026C13.6816 11.0581 13.5643 11.4582 13.2626 12.3885C13.1243 13.281 13.7078 13.1584 14.0169 12.9856L18.8252 9.73288C17.5157 8.79007 14.7145 6.81646 13.9854 6.46448C13.2563 6.1125 13.1998 6.64256 13.2626 6.9516L13.7026 8.42866H8.32859C7.49892 8.49152 7.20769 9.1672 7.16579 9.49718V17.6682Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.0314274
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightTurn);
export default __webpack_public_path__ + "static/media/rightTurn.e7b4e91400023dbbf85eb328ff214512.svg";
export { ForwardRef as ReactComponent };